import { useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { categories, movies } from '@/mocks/movies';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import MovieCard from '@/components/base/MovieCard';
import SEO from '@/components/base/SEO';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryMovies = movies.filter((m) => m.categorySlug === slug);
  const displayName = currentCategory?.name || '分类';

  const breadcrumbItems = [
    { name: '首页', url: '/' },
    { name: displayName, url: `/category/${slug}` },
  ];

  const seoKeywords = currentCategory
    ? `${currentCategory.name},${currentCategory.name}在线观看,免费${currentCategory.name},高清${currentCategory.name}`
    : '电影分类';

  return (
    <div className="min-h-screen bg-background-50">
      <SEO
        title={`${displayName} - 高清免费${displayName}在线观看 | 快看影视`}
        description={`快看影视为您提供${displayName}高清免费在线观看。精选${categoryMovies.length}部优质${displayName}，播放流畅不卡顿，${displayName}大全尽在快看影视。`}
        keywords={`${seoKeywords},快看影视`}
        canonicalUrl={`https://kuikanys.com/category/${slug}`}
      />
      <Navbar />
      <main className="pt-16">
        <div className="w-full px-4 md:px-6 pt-8 md:pt-10">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={breadcrumbItems} />

            <div className="mt-4 mb-6">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
                {displayName}
              </h1>
              <p className="text-sm text-foreground-400 mt-1">
                共 {categoryMovies.length} 部影片 · 快看影视精选{displayName}
              </p>
            </div>

            <div className="flex gap-2 overflow-x-auto pb-3 mb-6 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-950'
                      : 'bg-background-100 text-foreground-400 hover:text-foreground-200 hover:bg-background-200 border border-background-200/70'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryMovies.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 pb-12" data-product-shop>
                {categoryMovies.map((movie) => (
                  <MovieCard key={movie.id} {...movie} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 mx-auto mb-4">
                  <i className="ri-film-line text-2xl text-foreground-500"></i>
                </div>
                <p className="text-foreground-400">该分类暂无影片，请浏览其他分类</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}